import { createEvent, restore, sample } from 'effector'
import { SectionListRequest, SectionListResponse, SectionType } from './types'
import { fx } from '../../../../libs'

export const sectionListMounted = createEvent<SectionListRequest>()

export const getSectionList = fx<void, SectionListResponse>({
  method: 'GET',
  url: '/finance/section',
})

export const $sectionList = restore<SectionType[]>(
  getSectionList.doneData.map((a) => a.body.items),
  [],
)

export const $totalSectionList = restore(
  getSectionList.doneData.map((a) => a.body.total),
  0,
)

sample({
  // @ts-ignore
  clock: sectionListMounted,
  fn: ({ limit, page, orderBy, orderDirection }) => {
    if (orderDirection === 'descend') {
      orderDirection = '-'
    } else if (orderDirection === 'ascend') {
      orderDirection = ''
    }

    let query = {
      limit,
      page,
    }

    if (orderBy) {
      // @ts-ignore
      query['order'] = orderDirection + orderBy
    }

    return {
      url: `/finance/section`,
      query,
    }
  },
  target: getSectionList,
})
